/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize AntiBodyAntiHBs View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './AntiBodyAntiHBsView';

export const mapStateToPropsAntiBodyAntiHBs = mapStateToProps;
export const mapDispatchToPropsAntiBodyAntiHBs = mapDispatchToProps;

export default connect(
  mapStateToPropsAntiBodyAntiHBs,
  mapDispatchToPropsAntiBodyAntiHBs
)(View);
